import { FeaturedSideBarEntity } from "components/sidebar/domain/entities/FeatureSidebarEntity";

export class SidebarMenuConfigModel {
  constructor(public menu: FeaturedSideBarEntity[]) {}
}

export class FeaturedSideBarModel extends FeaturedSideBarEntity {
  constructor(data?: Partial<FeaturedSideBarEntity>) {
    super(data);
  }
}
